import apiClient from '../apiClient';
import { GET_REGION_LIST_URL } from '../apiUrl';

const getRegionListApi = () => {
  return apiClient.get(GET_REGION_LIST_URL);
};

export default getRegionListApi;
